(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-slider"] && !Shopify.designMode) return;
  try {
    /* Editor-only: BaseCarousel's shopify:block:select handler does items.indexOf(event.target),
   which is -1 for blocks NESTED inside a slide (quote paragraph etc.) and would crash the
   transition. Intercept in capture phase, stop it, and select the containing slide instead —
   so clicking any nested content block jumps the carousel to its slide. */
if (Shopify.designMode) {
  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.closest('.pl-product-slide');
    if (!slide || event.target === slide) return;
    event.stopPropagation();
    var carousel = slide.closest('.pl-product-slider__carousel');
    if (!carousel || typeof carousel.select !== 'function') return;
    var items = Array.prototype.slice.call(carousel.querySelectorAll('.pl-product-slide'));
    var index = items.indexOf(slide);
    if (index > -1) {
      carousel.select(index, { animate: !(event.detail && event.detail.load) });
    }
  }, true);
}
  } catch(e) { console.error(e); }
})();

})();
